import { http } from "./http.js";

async function searchReference(resource, filter) {
  const response = await http.get(
    `${resource}/referencies?`, { params: filter },
  );
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function getReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
  };
}

async function getAllReferencies(resource, params) {
  const response = await http.get(`${resource}/referencies`, { params });
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function getReferencies(resource, filter) {
  const response = await http.get(`${resource}/referencies?`, { params: filter });

  let responseData = response.data;
  if (Array.isArray(response.data) && response.data.length > 100) {
    responseData = response.data.splice(0, 100);
  }
  return responseData.map(i => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function getReferenceList(resource, id) {
  const response = await http.get(`${resource}/${id}`);
  return response;
}

async function getTinyReference(resource, queryParams) {
  const response = await http.get(
    "/" + resource + "?filter=all&" + queryParams,
  );
  return response.data.map((i) => {
    return {
      value: i.Id || i.Id === 0 ? i.Id : i,
      text: i.Title ? i.Title : i,
    };
  });
}

export {
  searchReference,
  getReference,
  getAllReferencies,
  getReferencies,
  getReferenceList,
  getTinyReference,
};
